import { render } from "./loading.vue?vue&type=template&id=73817412&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=73817412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73817412"]])

export default __exports__